import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  GroupSyncTypes,
  GroupSyncTypeNames,
  GroupSyncDescriptions,
} from "../../../constants/enums";
import { Radio, Form, Button, Skeleton, Typography, Popconfirm } from "antd";

const GroupSyncTypeSelector = ({
  groupType,
  loading,
  onChange,
  canManageGroup,
}) => {
  const [selectedGroupType, setSelectedGroupType] = useState(
    groupType || undefined
  );
  const [dirty, setDirty] = useState(false);

  const resetGroupType = () => {
    setSelectedGroupType(groupType);
    setDirty(false);
  };

  const submitGroupChange = async () => {
    await onChange(selectedGroupType);
    resetGroupType();
  };

  const handleChange = (e) => {
    setSelectedGroupType(e.target.value);
    setDirty(true);
  };

  const createRadioBox = (name) => (
    <Form.Item key={GroupSyncTypes[name]} style={{ marginBottom: 8 }}>
      <Radio
        value={name}
        checked={selectedGroupType === name}
        onChange={handleChange}
        disabled={!canManageGroup}
      >
        <Typography.Text strong>{GroupSyncTypeNames[name]}</Typography.Text>
        <Typography.Text type="secondary" style={{ marginLeft: 8 }}>
          - {GroupSyncDescriptions[name]}
        </Typography.Text>
      </Radio>
    </Form.Item>
  );

  return (
    <>
      {loading ? (
        <Skeleton active paragraph={{ rows: 3 }} />
      ) : (
        <>
          <Form layout="vertical">
            <Radio.Group
              name="radioGroup"
              value={selectedGroupType}
              onChange={handleChange}
            >
              {Object.keys(GroupSyncTypes).map((k) => createRadioBox(k))}
            </Radio.Group>
          </Form>
          <div style={{ marginTop: 24 }}>
            <Button
              id="resetSelectionButton"
              onClick={resetGroupType}
              disabled={!dirty}
              style={{ marginRight: 8 }}
            >
              Reset selection
            </Button>
            <Popconfirm
              title={
                <Typography.Title level={5} type="danger" style={{ margin: 0 }}>
                  Are you sure you wish to perform this operation?
                </Typography.Title>
              }
              onConfirm={submitGroupChange}
              onCancel={resetGroupType}
            >
              <Button
                id="changeButton"
                type="primary"
                disabled={!dirty || !canManageGroup}
              >
                Change
              </Button>
            </Popconfirm>
          </div>
        </>
      )}
    </>
  );
};

GroupSyncTypeSelector.propTypes = {
  groupType: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  canManageGroup: PropTypes.bool.isRequired,
};

export default GroupSyncTypeSelector;
